"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsLottie_1 = __importDefault(require("../typeAssertions/valueIsLottie"));
const cache = {};
const getLottieFromUrl = async (url, axios) => {
    if (cache[url]) {
        return cache[url];
    }
    try {
        const { data } = await axios.get(url);
        if (!(0, valueIsLottie_1.default)(data)) {
            return undefined;
        }
        cache[url] = data;
        return data;
    }
    catch (_a) {
        return undefined;
    }
};
exports.default = getLottieFromUrl;
